import React from 'react'
import PropTypes from 'prop-types'

import {VIEW_FULL, VIEW_PREVIEW} from '../../constants';
import SearchViewFull from '../SearchViewFull';
import SearchViewPreview from '../SearchViewPreview';

const mapViews = {
  [VIEW_FULL]: SearchViewFull,
  [VIEW_PREVIEW]: SearchViewPreview,
}

const ViewByKey = function ({type, children, ...props}) {
  const ViewComponent = mapViews[type];
  return (<ViewComponent {...props}>{children}</ViewComponent>)
}

ViewByKey.propTypes = {
  type: PropTypes.oneOf(Object.keys(mapViews)),
}

export default ViewByKey;
